// extracted by mini-css-extract-plugin
export var button = "_redotech-redo-customer-portal-returns-app-lib-returns-components-dropoffs-happy-returns-wallet-button-button";
export var walletBadge = "_redotech-redo-customer-portal-returns-app-lib-returns-components-dropoffs-happy-returns-wallet-button-wallet-badge";